export default Object.freeze({
  Text: 'text',
  Number: 'number',
  DateTime: 'dateTime',
  Date: 'date',
  Time: 'time',
  Array: 'array',
  File: 'file',
  Password: 'password',
});
